export default __webpack_public_path__ + "static/media/ico_feature_2.8876226d.svg";